// The contents of this file are replaced at the time of the build and the version string will be set to the build tag.

let version_object = {version: '2025.12.22.100522'};

export const { version } = version_object;  // jshint ignore: line

export default version_object;
